export class ChangePasswordRequest {
    public userID: number;
    public password: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/requests/change-password-request.model.ts